import { render } from "./tagLine.vue?vue&type=template&id=08311897&scoped=true"
import script from "./tagLine.vue?vue&type=script&lang=js"
export * from "./tagLine.vue?vue&type=script&lang=js"

import "./tagLine.vue?vue&type=style&index=0&id=08311897&lang=less&scoped=scoped"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08311897"]])

export default __exports__